export const PROJECT_ADMIN_TEXT = `
Please enter the email of the person in your organization who will be administering access to your Leap project.
`;

export const CONTACT_SUPPORT_HREF = 'mailto:support@dwavesys.com';
